import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { ArcaHttpSystem } from '../../code/ArcaHttpSystem';
import { ArcaLink } from './Fields/ArcaLink';

export class ModalPopup extends Component {

    constructor(props) {
        super(props);
        this.state = { modal: false };
    }

    render() {
        let { title, photo, text, textArray, onConfirm, onCancel, body } = this.props;

        return (
            <div>
                <Modal isOpen={true} toggle={onCancel} className="">
                    {title
                        ? <ModalHeader
                            toggle={onCancel}>{title}
                        </ModalHeader>
                        : null}

                    <ModalBody>
                        {text
                            ? <p>{text}</p>
                            : null}

                        {textArray?.map((txt, k) =>
                            <p key={k}>{txt}</p>
                        )}

                        {body
                            ? { body }
                            : null}

                        {photo
                            ? <img src={ArcaHttpSystem.PhotoFolder + photo + `.jpg`} className='center' width='90%' />
                            : null}

                    </ModalBody>
                    <ModalFooter>
                        {onConfirm
                            ? <ArcaLink colour="primary" onClick={onConfirm} text='Confirm' />
                            : null}
                        {' '}
                        {onCancel
                            ? <ArcaLink colour="secondary" onClick={onCancel} text='Cancel' />
                            : null}
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}